export enum RegistrationCodeValidationResults {
  unvalidated = -1,
  success = 0,
  campaignNotFound = 1,
  registrationCodeExpired = 2,
  campaignNotLive = 3,
  campaignNotSelfReg = 4,
  alreadyPaticipating = 5,
  unknownValidationFailure = 100
}
